import { ColorSet } from 'src/theme/colors';

interface GetAvatarColorConfig {
  colors: ColorSet;
  isWorkspace: boolean;
  level: number;
  name?: string;
}

export const getAvatarColor = ({ colors, isWorkspace, level, name }: GetAvatarColorConfig): string | undefined => {
  if (isWorkspace) {
    return colors.orgAvatarWorkspace || undefined;
  }

  if (level === 1) {
    // Only Cydea (by name) gets the root (prussianBlue) color
    // Other top-level organisations use parent org color
    if (name === 'Cydea') {
      return colors.orgAvatarRoot || undefined;
    }
    return colors.orgAvatarParent || undefined;
  }
  if (level === 2) {
    return colors.orgAvatarParent || undefined;
  }
  // Level 3+ uses sub org color
  return colors.orgAvatarSub || undefined;
};
